<span class="doc-validation-status loading" *ngIf="state == 'loading'">
  <span class="doc-validation-spinner"></span> Validando documento con Agente Vision...
</span>

<span class="doc-validation-status valid" *ngIf="state == 'valid'">
  <img src="/assets/qh-suite/icons/check_circle.svg" alt="Documento válido">
</span>

<span class="doc-validation-status invalid" *ngIf="state == 'invalid'">
  <img src="/assets/qh-suite/icons/close.svg" alt="Documento no válido">
  {{ reason || 'El documento no coincide con lo esperado.' }}
</span>
